"use strict";
import React from "react";
import { Flex, Image, useSporeColors } from "ui/src";
import { ALL_NETWORKS_LOGO } from "ui/src/assets";
import { iconSizes } from "ui/src/theme";
import { getChainInfo } from "features/chains/chainInfo";
import { isMobileWeb } from "utilities/src/platform";
export const SQUIRCLE_BORDER_RADIUS_RATIO = 0.3;
export function TransactionSummaryNetworkLogo({
  chainId,
  size = iconSizes.icon20
}) {
  return <NetworkLogo borderWidth={1.5} chainId={chainId} shape="square" size={size} />;
}
function _NetworkLogo({
  chainId,
  shape,
  size: sizeWithoutBorder = iconSizes.icon20,
  borderWidth = 0,
  borderRadius
}) {
  const size = sizeWithoutBorder + 2 * borderWidth;
  const shapeBorderRadius = shape === "circle" ? size / 2 : size * SQUIRCLE_BORDER_RADIUS_RATIO;
  const colors = useSporeColors();
  const _imageStyle = {
    width: size,
    height: size,
    borderRadius: borderRadius ?? shapeBorderRadius,
    borderWidth,
    borderColor: colors.surface1.val
  };
  if (chainId === null) {
    return <Flex testID="all-networks-logo">
        <NetworkImage logo={ALL_NETWORKS_LOGO} imageSize={size} />
      </Flex>;
  }
  const chainInfo = getChainInfo(chainId);
  const logo = chainInfo?.logo;
  const _imageSize = size - borderWidth * 2;
  return logo ? (
    // <Flex testID="network-logo" overflow="hidden" style={imageStyle} zIndex={zIndexes.mask}>
    //   <NetworkImage logo={logo} imageSize={imageSize} />
    // </Flex>
    <></>
  ) : null;
}
function NetworkImage({ logo, imageSize }) {
  return isMobileWeb && typeof logo === "string" ? <img src={logo} style={{ width: imageSize, height: imageSize }} /> : <Image resizeMode="contain" source={logo} width={imageSize} height={imageSize} />;
}
export const NetworkLogo = React.memo(_NetworkLogo);
